export default "__VITE_ASSET__955c659d__"